<template>
  <div>
    <a-tabs defaultActiveKey="1">
      <a-tab-pane key="1">
        <span slot="tab">
        <a-icon type="calendar" />
        Sanciones
       </span>
        <a-card>
          <g-master name="sanciones"
                    :endpoint="master.endpoint"
                    :tableSetup="master.tableSetup"
                    :modalFieldsSetup="master.modalFieldsSetup"
                    :parentData="parentData"
                    :actions="false"
          >
          </g-master>
        </a-card>
      </a-tab-pane>
    </a-tabs>
  </div>
</template>

<script>
  export default {
    props: ['id_person'],
    data () {
      return {
        master: {
          endpoint: 'atention_call',
          tableSetup: {
            actions: false,
            tableConfig: {
              rowKey: 'name'
            },
            columns: [
              {title: 'Fecha evento', dataIndex: 'call_date_desc', sorter: true},
              {title: 'Observación', dataIndex: 'accion_tomada', sorter: true},
              {title: 'Sanción', dataIndex: 'h_sanction', sorter: true}
            ]
          }
        }
      }
    },
    computed: {
      parentData () {
        return {
          id_person: this.id_person
        }
      }
    }
  }
</script>


// WEBPACK FOOTER //
// src/customization/GlobalBPOCore/pages/Empleados/Sanciones.vue